import { suppliers } from "../../mock";
import { SupplierBadge } from "./SupplierBadge";

export const Suppliers = () => (
  <section id="suppliers" data-testid="suppliers-section" className="py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-violet-400 mb-4">Supplier Portfolio</p>
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white max-w-2xl">
        400+ top-tier suppliers. Zero bias.
      </h2>
      <p className="mt-6 text-slate-400 max-w-xl">
        We negotiate directly with the industry's leading providers so you get the right technology — not the loudest sales pitch.
      </p>
      <div data-testid="suppliers-grid" className="mt-16 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {suppliers.map((s) => (
          <SupplierBadge key={s.name} name={s.name} domain={s.domain} />
        ))}
      </div>
      <p className="mt-12 text-center text-sm text-slate-500">…and 360+ more across every solution domain.</p>
    </div>
  </section>
);
